let currentIdToken = "";
let refreshTokenHandler: (() => Promise<string>) | null = null;
let refreshTokenPromise: Promise<string> | null = null;

export const authTokenStore = {
  get(): string {
    return currentIdToken;
  },

  set(token: string): void {
    currentIdToken = token;
  },

  clear(): void {
    currentIdToken = "";
  },

  hasToken(): boolean {
    return currentIdToken.length > 0;
  },

  registerRefreshHandler(handler: () => Promise<string>): () => void {
    refreshTokenHandler = handler;

    return () => {
      if (refreshTokenHandler === handler) {
        refreshTokenHandler = null;
        refreshTokenPromise = null;
      }
    };
  },

  refresh(): Promise<string> {
    if (!refreshTokenHandler) {
      return Promise.reject(new Error("Renovacao do token nao configurada"));
    }

    if (refreshTokenPromise) return refreshTokenPromise;

    const currentPromise = refreshTokenHandler();
    refreshTokenPromise = currentPromise;

    currentPromise.then(
      () => {
        if (refreshTokenPromise === currentPromise) refreshTokenPromise = null;
      },
      () => {
        if (refreshTokenPromise === currentPromise) refreshTokenPromise = null;
      },
    );

    return currentPromise;
  },
};
